// Sticky-scroll story: the product image stays pinned while feature "steps" scroll
// past; the active step (nearest viewport centre) lights up and the pinned card's
// caption (NN / label) + progress bar update. Self-contained custom element.
if (!customElements.get('sticky-scroll-story')) {
  customElements.define(
    'sticky-scroll-story',
    class StickyScrollStory extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-sss-step]'));
        this.capNum = this.querySelector('[data-sss-cap-num]');
        this.capLabel = this.querySelector('[data-sss-cap-label]');
        this.fill = this.querySelector('[data-sss-fill]');
        // Two stacked <img> layers crossfaded by opacity; frontLayer is the visible one.
        this.layers = Array.from(this.querySelectorAll('[data-sss-layer]'));
        this.frontLayer = 0;
        if (this.steps.length === 0) return;

        this.cur = -1;
        this.set(0);

        this.io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) this.set(this.steps.indexOf(e.target));
            });
          },
          { rootMargin: '-48% 0px -48% 0px', threshold: 0 }
        );
        this.steps.forEach((s) => this.io.observe(s));
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }

      set(i) {
        if (i < 0 || i === this.cur) return;
        this.cur = i;
        this.steps.forEach((s, j) => s.classList.toggle('is-on', j === i));
        const step = this.steps[i];
        if (this.capNum) this.capNum.textContent = step.getAttribute('data-sss-num') || '';
        if (this.capLabel) this.capLabel.textContent = step.getAttribute('data-sss-label') || '';
        if (this.fill) this.fill.style.height = ((i + 1) / this.steps.length) * 100 + '%';

        // Crossfade the pinned photo to this step's image using two stacked layers — the
        // incoming image is written to the hidden layer and faded in over the outgoing one, so
        // nothing translates or reframes (a true opacity crossfade, not a src-swap on a visible img).
        if (this.layers && this.layers.length === 2) {
          const url = step.getAttribute('data-sss-img');
          const front = this.layers[this.frontLayer];
          if (url && front && front.getAttribute('src') !== url) {
            const nextIdx = this.frontLayer === 0 ? 1 : 0;
            const next = this.layers[nextIdx];
            const reveal = () => {
              next.classList.add('is-front');
              front.classList.remove('is-front');
              this.frontLayer = nextIdx;
            };
            if (next.getAttribute('src') === url) {
              reveal();
            } else {
              const pre = new Image();
              pre.onload = () => { next.src = url; reveal(); };
              pre.onerror = () => { next.src = url; reveal(); };
              pre.src = url;
            }
          }
        }
      }
    }
  );
}
